import React, { Component } from 'react';
import About from './resume-components/about';
import WorkExperience from './resume-components/work-experience';
import Education from './resume-components/education';
import Training from './resume-components/training';
import Skills from './resume-components/skills';
import Hobbies from './resume-components/hobbies';

class Resume extends Component {
  
  render() {
    const myResume = (
    <div className="resume-container">
        <About />
        <WorkExperience />
        <Education />
        <Training />
        <Skills />
        <Hobbies />
    </div>
    );
    return (
         myResume
    );
  }
  
}

export default Resume;



// WEBPACK FOOTER //
// ./src/components/resume.js